// Angular
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
// Service 
import { AuthService } from '../../../../../core/services/auth.service';

@Component({
  selector: 'kt-user-profile4',
  templateUrl: './user-profile4.component.html',
})
export class UserProfile4Component implements OnInit {
  // Public properties
  user;
  loaded = false;
  fullname;
  role;

  @Input() avatar = true;
  @Input() greeting = true;
  @Input() badge: boolean;
  @Input() icon: boolean;

  /**
   * Component constructor
   *
   * @param store: Store<AppState>
   */
  constructor(
    private router: Router, 
    private auth: AuthService, 
    private cdr: ChangeDetectorRef
  ) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit(): void {
    this.auth.profile().subscribe((_res) => {
      this.user = _res;
      this.fullname = _res.names + ' ' + _res.lastNames
      switch (_res.userType) {
        case 'OWNER':
          this.role = 'Administrador';
          break;
        case 'COMPANY':
          this.role = 'Aseguradora';
          break;
        case 'BROKER':
          this.role = 'Intermediario';
          break;
        default:
          this.role = 'Usuario';
          break;
      }
      this.loaded = true;
      this.cdr.markForCheck();
    })
  }

  /**
   * Log out
   */
  logout() {
    window.localStorage.removeItem('token');
    this.router.navigateByUrl('/auth/login');
  }
}
